export function isURL(str) {
  if (!str) return false;

  const cleaned = str.replace(/[\u200B-\u200D\uFEFF\u00A0]/g, '').trim();
  if (!cleaned) return false;

  /* eslint-disable no-control-regex */
  if (/[^\x00-\x7F]/.test(cleaned)) return false;

  const ipv4Seg = '(?:25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)';
  const IPv4 = `(?:${ipv4Seg}\\.){3}${ipv4Seg}`;

  const DOMAIN = '(?=.{1,253}$)(?:' + '(?!-)[A-Za-z0-9-]{1,63}(?<!-)\\.)+' + '[A-Za-z]{2,63}';

  const PORT = '(?::\\d{1,5})?';
  const PATH = "(?:\\/[A-Za-z0-9._~:/?#[\\]@!$&'()*+,;=%-]*)?";

  const withScheme = new RegExp(`^\\s*(?:https?:\\/\\/)(?:${DOMAIN}|${IPv4})${PORT}${PATH}\\s*$`);
  const bareDomain = new RegExp(`^\\s*${DOMAIN}${PORT}${PATH}\\s*$`);
  const bareIP = new RegExp(`^\\s*${IPv4}${PORT}${PATH}\\s*$`);

  if (!(withScheme.test(cleaned) || bareDomain.test(cleaned) || bareIP.test(cleaned))) return false;

  try {
    const probe =
      withScheme.test(cleaned) || bareIP.test(cleaned)
        ? cleaned.startsWith('http')
          ? cleaned
          : `http://${cleaned}`
        : `http://${cleaned}`;
    const u = new URL(probe);
    const host = u.hostname;

    const domainOk = /^[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/.test(host) && /[A-Za-z]{2,}$/.test(host);
    const ipv4Ok = new RegExp(`^${IPv4}$`).test(host);

    return domainOk || ipv4Ok;
  } catch {
    return false;
  }
}

export function isDomain(str) {
  const trimmed = str.trim();
  return /^(?:[a-z0-9-]+\.)+[a-z]{2,}$/i.test(trimmed);
}

export function isEmail(str) {
  const trimmed = str.trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
}

export function isPhone(str) {
  const trimmed = str.trim();

  // Only match if input doesn't contain any non-phone characters (no message context)
  if (/[^0-9+()\-.\sextx#]/i.test(trimmed)) return false;

  const raw = trimmed.replace(/(?:ext\.?|extension|x|#)\s*\d+$/i, '').replace(/[^\d+]/g, '');

  return (
    /^(\+?86)?1[3-9]\d{9}$/.test(raw) || // CN mobile
    /^(\+?86)?(?:0\d{2,3}[- ]?)?\d{7,8}$/.test(raw) || // CN landline opt area
    /^(\+?61|0)?4\d{8}$/.test(raw) || // AU mobile
    /^(\+?61|0)?[2378]\d{8}$/.test(raw) || // AU landline opt area
    /^(\+?64|0)?2\d{7,9}$/.test(raw) || // NZ mobile
    /^(\+?64|0)?[34679]\d{7,8}$/.test(raw) || // NZ landline opt area
    /^\+[1-9]\d{7,14}$/.test(raw) || // E.164
    (/^\d{7,8}$/.test(raw) && !/[a-z]/i.test(trimmed)) // local landline (no area)
  );
}

export function isBankAccount(str) {
  const trimmed = str.trim();

  // Reject anything that has non-digit / non-space stuff
  if (/[^0-9\- ]/.test(trimmed)) return false;

  const digits = trimmed.replace(/\D+/g, '');

  const luhn = (() => {
    let sum = 0,
      dbl = false;
    for (let i = digits.length - 1; i >= 0; i--) {
      let d = parseInt(digits[i], 10);
      if (dbl) {
        d *= 2;
        if (d > 9) d -= 9;
      }
      sum += d;
      dbl = !dbl;
    }
    return digits.length > 0 && sum % 10 === 0;
  })();

  return (
    /^(?:\d{3})[- ]?\d{3}[- ]?\d{5,10}$/.test(trimmed) || // AU BSB
    /^\d{2}-\d{4}-\d{6,8}-\d{2,4}$/.test(trimmed) || // NZ NUBAN
    /^\d{3}-\d{4}-\d{7,14}$/.test(trimmed) || // TW-like
    (/^[\d -]{12,25}$/.test(trimmed) && digits.length >= 12 && digits.length <= 19 && luhn)
  );
}

export function isOnlyCtaInput(str) {
  return isURL(str);
}
